import React from "react";

import { useTunnels } from "../../context/tunnels";
import DropdownMenu from "../dropdownMenu/DropdownMenu";
import { withInternalFallback } from "../hoc/withInternalFallback";

import * as DefaultItems from "./DefaultItems";

const MainMenu = Object.assign(
  withInternalFallback("MainMenu", () => {
    const { MainMenuTunnel } = useTunnels();
    return <MainMenuTunnel.In>{null}</MainMenuTunnel.In>;
  }),
  {
    Trigger: DropdownMenu.Trigger,
    Item: DropdownMenu.Item,
    ItemLink: DropdownMenu.ItemLink,
    ItemCustom: DropdownMenu.ItemCustom,
    Group: DropdownMenu.Group,
    Separator: DropdownMenu.Separator,
    DefaultItems,
  },
);

export default MainMenu;
